import React from 'react';
import { AccountDarkCharcoalImage } from '../../../parts/svgImages/AccountImage';
import { HelpDarkCharcoalImage } from '../../../parts/svgImages/HelpImage';
import { PointDarkCharcoalImage } from '../../../parts/svgImages/PointImage';
import type { JSX } from 'react';
import type { Config } from 'u-next/config';

export function generateHeaderMenuList(options: Config) {
  return [
    {
      url: `${options.MYACCOUNT}/unext-point`,
      text: 'U-NEXTポイント',
      icon: <PointDarkCharcoalImage alt="" />,
    },
    {
      url: `${options.MYACCOUNT}/settings`,
      text: 'アカウント・契約',
      icon: <AccountDarkCharcoalImage alt="" />,
    },
    {
      url: options.HELP,
      text: 'ヘルプ',
      icon: <HelpDarkCharcoalImage alt="" />,
    },
  ];
}

export const StyledIcon: React.FC<
  {
    jsx: JSX.Element;
  } & React.ImgHTMLAttributes<HTMLImageElement>
> = ({ jsx, ...attr }) => React.cloneElement(jsx, attr);
